<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="blue-grey lighten-2">
            <v-toolbar-title>{{ $t('FORGOT_TITLE') }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-card-text v-if="!submitted">
            <p>{{ $t('FORGOT_INTRO') }}</p>
            <v-form @submit.prevent="onSubmit">
              <v-text-field
                v-model="email"
                prepend-icon="email"
                :label="$t('EMAIL')"
                type="email"
                required
                @keyup.enter="onSubmit"
              ></v-text-field>
            </v-form>
          </v-card-text>

          <v-card-actions v-if="!submitted">
            <v-spacer></v-spacer>
            <v-btn dark color="amber darken-4" :loading="loading" @click="onSubmit">
              {{ $t('FORGOT_SUBMIT') }}
            </v-btn>
          </v-card-actions>

          <v-card-text v-else>
            <v-alert :value="true" type="success" outlined>
              {{ $t('FORGOT_SENT') }}
            </v-alert>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <router-link to="/login" style="margin-right:16px;margin-bottom:8px">
              {{ $t('BACK_TO_LOGIN') }}
            </router-link>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { requestPasswordReset } from '../services/login.service';

export default {
  name: 'ForgotPassword',
  data() {
    return { email: '', loading: false, submitted: false };
  },
  methods: {
    async onSubmit() {
      if (!this.email || this.loading) return;
      this.loading = true;
      try {
        await requestPasswordReset(this.email, this.$i18n.locale);
      } catch (e) {
        // bewusst ignoriert — keine Enumeration-Hints
      } finally {
        this.loading = false;
        this.submitted = true;
      }
    },
  },
};
</script>
